import { connect } from "react-redux";

// Component
// import Dashboard from '../../views/Dashboard';
import Dashboard from "./Dashboard.jsx";

// Actions
import {
  getDashboardData,
  getDashboardLeads,
  getGroupList,
  getGroupwiseData,
} from "./dashboardActions";

// Store props to map with current state
const mapStateToProps = (state) => {
  if (
    state.dashboard?.subscriptionStatus === "inactive" ||
    state.dashboard?.subscriptionStatus === "paused"
  ) {
    return {
      isLoading: state.dashboard.isLoading,
      status: state.dashboard.subscriptionStatus,
      redirect: state.dashboard.redirect,
      error: state.dashboard.error,
      recentLeads: state.dashboard.recentLeads,
      recentLeadsError: state.dashboard.recentLeadsError,
      recentLeadsLoading: state.dashboard.recentLeadsLoading,
    };
  }
  return {
    dashboardData: state.dashboard.data,
    groupList: state.dashboard.groupList,
    // status: "inactive",
    isLoading: state.dashboard.isLoading,
    redirect: state.dashboard.redirect,
    error: state.dashboard.error,
    status: state.dashboard.subscriptionStatus,
    recentLeads: state.dashboard.recentLeads,
    recentLeadsError: state.dashboard.recentLeadsError,
    recentLeadsLoading: state.dashboard.recentLeadsLoading,
  };
};

// Actions prop to dispatch
const mapDispatchToProps = (dispatch) => ({
  getDashboardData: (data) => dispatch(getDashboardData(data)),
  getDashboardLeads: () => dispatch(getDashboardLeads()),
  getGroupList: () => dispatch(getGroupList()),
  getGroupwiseData: (details) => dispatch(getGroupwiseData({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
